module.exports = __webpack_public_path__ + "img/14980e64fe776bed186d27b07f27ed07.svg";